<template>
  <el-dialog
    title="添加商家优惠券池"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="addCouponShopPoolInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="优惠券" prop="poolId">
        <el-input v-model="addCouponShopPoolInfo.poolId" placeholder="必填，请填写优惠券"></el-input>
      </el-form-item>
      <el-form-item label="店铺" prop="shopId">
        <el-input v-model="addCouponShopPoolInfo.shopId" placeholder="必填，请填写店铺ID"></el-input>
      </el-form-item>
      <el-form-item label="面值" prop="actualPrice">
        <el-input v-model="addCouponShopPoolInfo.actualPrice" type="number" placeholder="必填，请填写面值"></el-input>
      </el-form-item>
      <el-form-item label="库存" prop="stock">
        <el-input v-model="addCouponShopPoolInfo.stock" type="number" placeholder="必填，请填写库存"></el-input>
      </el-form-item>
      <el-form-item label="有效期" prop="validityDay">
        <el-input v-model="addCouponShopPoolInfo.validityDay" type="number" placeholder="必填，请填写有效期"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveCouponShopPoolInfo">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveCouponShopPool } from '@/api/goods/couponShopPoolApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddCouponShopPool',
  data() {
    return {
      dialogVisible: false,
      addCouponShopPoolInfo: {
        spId: '',
        poolId: '',
        shopId: '',
        couponName: '',
        actualPrice: '',
        stock: '',
        validityDay: '',
        caId: ''
      },
      rules: {
        poolId: [
          { required: true, message: '优惠券不能为空', trigger: 'blur' },
          { max: 30, message: '优惠券不能超过30个字符', trigger: 'blur' }
        ],
        shopId: [
          { required: true, message: '店铺ID不能为空', trigger: 'blur' },
          { max: 30, message: '店铺ID不能超过30个字符', trigger: 'blur' }
        ],
        actualPrice: [
          { required: true, message: '面值不能为空', trigger: 'blur' },
          { max: 10, message: '面值不能超过10个字符', trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '库存不能为空', trigger: 'blur' },
          { max: 20, message: '库存不能超过20个字符', trigger: 'blur' }
        ],
        validityDay: [
          { required: true, message: '有效期不能为空', trigger: 'blur' },
          { max: 20, message: '有效期不能超过20个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.clearAddCouponShopPoolInfo()
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    saveCouponShopPoolInfo() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.addCouponShopPoolInfo.caId = getShopId()
          try {
            await saveCouponShopPool(this.addCouponShopPoolInfo)
            this.$emit('refresh')
            this.dialogVisible = false
            this.$message.success('添加成功')
          } catch (error) {
            console.error(error)
          }
        }
      })
    },
    clearAddCouponShopPoolInfo() {
      console.log(this.addCouponShopPoolInfo.couponName)
      this.addCouponShopPoolInfo = {
        spId: '',
        poolId: '',
        shopId: '',
        couponName: '',
        actualPrice: '',
        stock: '',
        validityDay: '',
        caId: ''
      }
    }
  }
}
</script>